import Box from './Box';
import React from 'react';
import Text from './Text';
import Badge from './Badge';
import { translate } from '../locale';
import { useBooking } from '../BookingProvider';
import CourseItemDetail from './CourseItemDetail';

export default function CourseListViewItem({ course, onClick }) {
  const { locale } = useBooking();

  const language = course.language || 'de';
  const translatedLanguageLabel = translate(locale, 'infoMessage', 'languageInfo');
  const translatedLanguage = translate(locale, 'language', language);

  return (
    <Box padding={16} divider cursor='pointer' onClick={onClick}>
      <Box direction='row' alignItems='center' >
        <Box width='flex'>
          <CourseItemDetail course={course} hideCity={true} />
        </Box>
        <Box direction='column'>
          {
            course.freePlaces === 0 ?
              <Text weight={'500'} textAlignRight color='red'>{translate(locale, 'infoMessage', 'coursesFree_zero')}</Text> :
              <Text weight={'500'} textAlignRight color='green'>{course.freePlaces} {translate(locale, 'infoMessage', course.freePlaces === 1 ? 'coursesFree_singular' : 'coursesFree')}</Text>
          }
          <Badge
            label={`${translatedLanguageLabel}: ${translatedLanguage}`}
            style={
              language !== 'de' ?
                {
                  backgroundColor: 'var(--red-color)',
                  color: '#fff'
                } :
                undefined
            }
          />
        </Box>
      </Box>
    </Box>
  );
}